export const MEMBERTYPE_MASTER = "MASTER";
export const MEMBERTYPE_MEMBER = "MEMBER";
export const MEMBERTYPE_NONE = "NONE";
export const MemberTypeText = {
  NONE: '-',
  MASTER: '마스터',
  MEMBER: '멤버'
};

/***
 * 캠페인 상태
 */
class campaignStatus {
  value = "VALUE";
  text = "TEXT";
  sortOrder = -1;

  constructor(value, text, sortOder) {
    this.value = value;
    this.text = text;
    this.sortOrder = sortOder;
  }

  toString() {
    return this.text;
  }
}

export const CAMPAIGN_STATUS = {
  TEMPORARY: new campaignStatus("TEMPORARY", "임시등록", 2),
  SCHEDULED: new campaignStatus("SCHEDULED", "예정", 1),
  ONGOING: new campaignStatus("ONGOING", "진행중", 0),
  ON_DISPLAY: new campaignStatus("ON_DISPLAY", "노출중", 0),
  ENDED: new campaignStatus("ENDED", "종료", 2)
}
